const normalize = {
  // Brawl Stars -> brawl-stars
  hyphenateAndLowerCase: str => {
    return str && str.replace(/[\s[\]:]/g, '-').toLowerCase();
  },
  // brawl-stars -> Brawl Stars
  unhyphenateAndLowerCase: str => {
    return str && str.replace(/-/g, ' ').toLowerCase();
  },
  // https://www.gamerhub.gg/example -> www.gamerhub.gg/example
  stripHttp: str => {
    return str && str.replace(/http(s)?:\/\//, '');
  },
  requireHttp: str => {
    let result = str;
    if (str && !str.startsWith('http')) {
      result = `https://${result}`;
    }
    return result;
  }
};

module.exports = {
  normalize
};
